export const getQueryFromLink = (url: string) => {
  let query = "";
  
  try {
    const urlObj = new URL(url);
    query = urlObj.search;
  } catch (e) {
    console.error("variable url is not a url");
  }

  return query;
};
